export const HEADER_DISABLED_KEY = "disableHeader";
export const SS_CHANGED = "ss:changed";

export function setSessionItem(key: string, value: string) {
    try {
        if (typeof window === "undefined") return;
        window.sessionStorage.setItem(key, value);
        window.dispatchEvent(new CustomEvent(SS_CHANGED, {detail: {key, value }}));
    } catch {}
}

export function getSessionItem(key: string) {
    try {
        if (typeof window === "undefined") return null;
        return window.sessionStorage.getItem(key);
    } catch {return null}
}